export default function (header) {
	// The fade ends at 80px so it is halfway at 40px, where the bar used to switch at once.
	const handleScroll = () => {
		const progress = Math.min(window.scrollY / 80, 1);

		header.style.setProperty('--scroll-progress', progress);
		header.classList.toggle('scrolled', progress > 0);
	};

	const languages = header.querySelector('.languages');

	const closeMenu = (event) => {
		if (languages.open && !languages.contains(event.target)) {
			languages.open = false;
		}

		if (header.classList.contains('open') && (!header.contains(event.target) || event.target.closest('a'))) {
			header.classList.remove('open');
		}
	};

	header.querySelector('.hamburger').addEventListener('click', () => header.classList.toggle('open'));
	window.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && languages.open) {
			languages.open = false;
			languages.querySelector('summary').focus();
		}
	});
	// The other language's page at the same section.
	header.querySelectorAll('.languages a').forEach((link) => link.addEventListener('click', () => {
		link.hash = location.hash;
	}));
	window.addEventListener('scroll', handleScroll, { passive: true });
	window.addEventListener('click', closeMenu);
	handleScroll();
}
